<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Upload"></app-page-title>
        <form [formGroup]="rateUploadForm" (ngSubmit)="uploadRates();">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="rateType" class="form-label">Rate Type <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="rateType" placeholder="Select" [items]="rateTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlRateType" bindLabel="ratetype"
                                            [bindValue]="'id'" (change)="onChangeRateType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlRateType').touched) && rateUploadForm.get('ddlRateType').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlRateType').touched) && rateUploadForm.get('ddlRateType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('ddlRateType').errors.required">Rate Type is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="showCategory">
                                    <div class="mb-2">
                                        <label for="rateCategoryType" class="form-label">Category <span
                                            class="mandatory">*</span></label>
                                        <ng-select id="rateCategoryType" placeholder="Select"
                                            [items]="rateCategoriesList" [appendTo]="'body'" [openOnEnter]="false"
                                            formControlName="ddlRateCategory" bindLabel="ratecategory"
                                            [bindValue]="'id'" groupBy="category" (change)="onChangeRateCategory()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlRateCategory').touched) && rateUploadForm.get('ddlRateCategory').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlRateCategory').touched) && rateUploadForm.get('ddlRateCategory').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('ddlRateCategory').errors.required">Category
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="rateCategoryType" class="form-label">Type<span
                                            class="mandatory">*</span></label>
                                        <ng-select id="ratetype" placeholder="Select"
                                            [items]="ratecategorytypeList" [appendTo]="'body'" [openOnEnter]="false"
                                            formControlName="ddlType" bindLabel="name"
                                            [bindValue]="'value'"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlType').touched) && rateUploadForm.get('ddlType').errors}"  >
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlType').touched) && rateUploadForm.get('ddlType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('ddlType').errors.required">Rate type
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="showDownloadBtn">
                                    <div class="col-md-2">
                                        <label class="form-label mb-0"></label>
                                        <div class="">
                                            <button type="button" class="btn btn-primary btn-sm d-flex"
                                                (click)="downloadFormatFile()">
                                                <i class="bx bx-download font-size-15 me-1"></i> Download
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label for="fromDate" class="form-label">Period Range <span
                                        class="mandatory">*</span></label>
                                    <div class="input-daterange input-group" data-provide="datepicker">
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate" placeholder="From"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('txtFromDate').touched) && rateUploadForm.get('txtFromDate').errors}"  >
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('txtFromDate').touched) && rateUploadForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('txtFromDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('txtToDate').touched) && rateUploadForm.get('txtToDate').errors}"  >
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('txtToDate').touched) && rateUploadForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('txtToDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>

                                    <!-- <div class="mb-2">
                                        <label for="fromDate" class="form-label">From Date <span
                                                class="mandatory">*</span></label>
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('txtFromDate').touched) && rateUploadForm.get('txtFromDate').errors}"  >
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('txtFromDate').touched) && rateUploadForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('txtFromDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div> -->
                                </div>
                                <!-- <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="toDate" class="form-label">To Date <span
                                                class="mandatory">*</span></label>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('txtToDate').touched) && rateUploadForm.get('txtToDate').errors}"  >
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('txtToDate').touched) && rateUploadForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('txtToDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row">
                                <ng-container *ngIf="showBands">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="rateBands" class="form-label">Rate Bands <span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="rateBands" [items]="rateBandList" bindLabel="rateband"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                formControlName="ddlRateBand"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlRateBand').touched) && rateUploadForm.get('ddlRateBand').errors}"  >
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlRateBand').touched) && rateUploadForm.get('ddlRateBand').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="rateUploadForm.get('ddlRateBand').errors.required">Rate
                                                    Band is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showCustomer">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="customerRate" class="form-label">Customer <span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="customerRate" [items]="customerList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                (change)="checkCustContract()"
                                                formControlName="ddlCustomer"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlCustomer').touched) && rateUploadForm.get('ddlCustomer').errors}"  >
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlCustomer').touched) && rateUploadForm.get('ddlCustomer').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="rateUploadForm.get('ddlCustomer').errors.required">Customer
                                                    is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showVendor">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="headerVendor" class="form-label">Vendor<span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="headerVendor" [items]="vendorList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                formControlName="ddlVendor"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('ddlVendor').touched) && rateUploadForm.get('ddlVendor').errors}"  >
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || rateUploadForm.get('ddlVendor').touched) && rateUploadForm.get('ddlVendor').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="rateUploadForm.get('ddlVendor').errors.required">Vendor is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-label">( <small
                                        for=""><i class="mdi mdi-information">Note: xls are only allowed.</i></small> )</label>
                                    <div class="input-group">
                                        <input type="file" class="form-control form-control-sm" accept=".xlsx,.xls"
                                            id = "importrates"
                                            formControlName="fileControl" (change)="onChangeFileSelect($event)"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateUploadForm.get('fileControl').touched) && rateUploadForm.get('fileControl').errors}"  >
                                        <button type="submit" class="btn btn-primary btn-sm d-flex" >
                                            <i class="bx bx-upload font-size-15 me-1"></i> Upload
                                        </button>
                                        <div *ngIf="(isFormSubmitted || rateUploadForm.get('fileControl').touched) && rateUploadForm.get('fileControl').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="rateUploadForm.get('fileControl').errors.required">Select file
                                                to upload</span>
                                        </div>
                                    </div>
                                    <div *ngIf="showProgressBar" class="progress mt-2">
                                        <div class="progress-bar progress-bar-striped" role="progressbar"
                                            [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0"
                                            aria-valuemax="100">
                                            {{progress}}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Rate Periods</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowDataPeriod" [columnDefs]="columnDefsPeriod"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReadyPeriod($event)"
                                [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="showRateDetails">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Rate Details</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowDataInfo" [columnDefs]="columnDefs"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                                [gridOptions]="gridOptions">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <app-rateperiod (onClose)="onClosePeriod($event)" (updated)="onUpdatePeriod($event)"
                    [(showPeriodModal)]="showPeriodModal" [(periodData)]="periodData"
                    [(rateTypes)]="rateTypeList"></app-rateperiod>
            </div> -->
            <!-- <div class="row">
                <app-ratedetails (onClose)="onCloseRateDetails($event)" (updated)="onUpdateRateDetails($event)"
                    [(showRateModal)]="showRateModal" [(rateDetailData)]="rateDetailData"></app-ratedetails>
            </div> -->
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>